import styled from "styled-components";

export const ModalContainer = styled.div`

    & > div {
        /* margin: 15px 0; */
    }

`;